import script from "./UserReport.vue?vue&type=script&setup=true&lang=js"
export * from "./UserReport.vue?vue&type=script&setup=true&lang=js"

import "./UserReport.vue?vue&type=style&index=0&id=423529a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-423529a6"]])

export default __exports__